/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GlobalTinVerificationRequestV1 } from '../models/global-tin-verification-request-v-1';
import { VerificationResultResponseV1 } from '../models/verification-result-response-v-1';


/**
 * API to trigger global TIN verification with caching
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalTinVerificationV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verifyGlobalTinv1
   */
  static readonly VerifyGlobalTinv1Path = '/v1/global-tin-verification';

  /**
   * Trigger global TIN verification with caching.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyGlobalTinv1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyGlobalTinv1$Response(params: {

    /**
     * Global TIN verification request
     */
    body: GlobalTinVerificationRequestV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<VerificationResultResponseV1>> {

    const rb = new RequestBuilder(this.rootUrl, GlobalTinVerificationV1Service.VerifyGlobalTinv1Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VerificationResultResponseV1>;
      })
    );
  }

  /**
   * Trigger global TIN verification with caching.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyGlobalTinv1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyGlobalTinv1(params: {

    /**
     * Global TIN verification request
     */
    body: GlobalTinVerificationRequestV1
  },
  context?: HttpContext

): Observable<VerificationResultResponseV1> {

    return this.verifyGlobalTinv1$Response(params,context).pipe(
      map((r: StrictHttpResponse<VerificationResultResponseV1>) => r.body as VerificationResultResponseV1)
    );
  }

}
